import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, interval, Subscription } from 'rxjs'
import { map, startWith, switchMap } from 'rxjs/operators'
import { LogService } from 'htv-lib'
import { MessageDto } from '../interfaces/message'
import { MessageService } from './message.service'

@Injectable({
  providedIn: 'root',
})
export class MessageStateService {
  private readonly POLLING_INTERVAL_MS = 120000

  private messagesSubject = new BehaviorSubject<MessageDto[]>([])
  private pollingSubscription?: Subscription
  private refreshSubscription?: Subscription

  public messages$: Observable<MessageDto[]> = this.messagesSubject.asObservable()

  public unreadCount$: Observable<number> = this.messages$.pipe(map(messages => messages.filter(m => !m.readAt).length))

  constructor(
    private messageService: MessageService,
    private logService: LogService
  ) {
    // do nothing
  }

  startPolling(): void {
    if (this.pollingSubscription) {
      return
    }

    this.pollingSubscription = interval(this.POLLING_INTERVAL_MS)
      .pipe(
        startWith(0),
        switchMap(() => this.messageService.getMessages())
      )
      .subscribe({
        next: messages => {
          this.messagesSubject.next(messages)
        },
        error: error => {
          this.logService.error(`Error polling messages: ${error}`)
        },
      })
  }

  stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe()
      this.pollingSubscription = undefined
    }
  }

  refreshMessages(): void {
    this.refreshSubscription?.unsubscribe()
    this.refreshSubscription = this.messageService.getMessages().subscribe({
      next: messages => {
        this.messagesSubject.next(messages)
      },
      error: error => {
        this.logService.error(`Error refreshing messages: ${error}`)
      },
    })
  }
}
